import React, { useRef, useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Section, TextColumn, Automec, TextoAbaixo } from "./../styles/styles";
import estatua from "./../styles/achiles.png";
import web1 from "./../styles/web1.png";
import web2 from "./../styles/web2.png";
import web3 from "./../styles/web3.png";
import web4 from "./../styles/web4.png";
import web5 from "./../styles/web5.png";

const conteudos = [
  {
    titulo: "Overview",
    desc: [
      {
        text: " Developed a comprehensive visual asset package for Instagram to showcase the HEX Pad line. The goal was to communicate product variety and technical specifications clearly to a B2B audience. I was responsible for the full creative cycle: from 3D modeling and rendering to final graphic composition and grid strategy.",
      },
      {
        title: "Role:",
        text: "Web Designer",
      },
      {
        title: "Responsibilities:",
        text: "3D Modeling, Lookdev/Rendering, Information Architecture, Typography, and Social Media Asset Creation.",
      },
    ],
    img: web1,
  },
  {
    titulo: "Challenge",
    desc: [
      {
        text: "The client needed to present a complex product line (different sizes and mechanical functions) in a way that was both visually engaging and easy to understand. The main hurdle was creating a flexible system that worked across different platforms (Instagram Feed, Stories, and WhatsApp) while maintaining the strict brand identity of Sigma Tools.",
      },
    ],
    img: web2,
  },
  {
    titulo: "Solution",
    desc: [
      {
        title: "Dynamic Layout:",
        text: "Developed a grid that combined realistic 3D renders with clear technical typography, highlighting size options directly beside the product.",
      },
      {
        title: "Multi-Platform Delivery:",
        text: "Organized a file structure that allowed for seamless adaptation between Feed, Stories, and direct sales catalogs (WhatsApp).",
      },
    ],
    img: web3,
  },
  {
    titulo: "Solution",
    desc: [
      {
        title: "3D Asset Creation:",
        text: "Modeled high-fidelity 3D pads to ensure visual consistency across all sizes ($83$mm, $125$mm, $150$mm), eliminating the need for expensive photoshoots.",
      },
      {
        title: "Visual Coding:",
        text: "Applied a color-coded system to represent each pad’s specific use (Heavy Cut, Medium Cut, Polishing, etc.), facilitating quick identification for B2B buyers.",
      },
    ],
    img: web4,
  },
  {
    titulo: "Results",
    desc: [
      {
        title: "Commercial Impact:",
        text: "Contributed to a 10% increase in sales by significantly improving product visibility and clarity for the B2B market.",
      },
      {
        title: "High-Volume Output:",
        text: "Delivered a robust library of assets, including 16 high-fidelity 3D models and 22 custom render assets..",
      },
      {
        title: "Creative Efficiency:",
        text: "Successfully produced 14 final marketing images designed for high engagement and versatile use across digital platforms..",
      },
      {
        title: "Brand Authority:",
        text: "Strengthened Sigma Tools' market position through professional, consistent, and technically accurate visual communication.",
      },
    ],
    img: web5,
  },
];

const ProjetoMarketing = () => {
  const containerRef = useRef(null);
  const [dragWidth, setDragWidth] = useState(0);

  useEffect(() => {
    const calcularWidth = () => {
      if (!containerRef.current) return;

      const scrollWidth = containerRef.current.scrollWidth;
      const offsetWidth = containerRef.current.offsetWidth;

      setDragWidth(scrollWidth - offsetWidth);
    };

    calcularWidth();
    window.addEventListener("resize", calcularWidth);

    return () => window.removeEventListener("resize", calcularWidth);
  }, []);

  return (
    <div
      ref={containerRef}
      style={{
        width: "100%",
        overflow: "hidden",
        position: "relative",
      }}
    >
      <motion.div
        drag="x"
        dragConstraints={{ left: -dragWidth, right: 0 }}
        dragElastic={0.1}
        dragMomentum={false}
        style={{
          display: "flex",
          width: "max-content",
          cursor: "grab",
        }}
        whileTap={{ cursor: "grabbing" }}
      >
        {conteudos.map((item, index) => (
          <Section
            key={index}
            style={{
              width: "1500",
              flexShrink: 0,
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              paddingLeft: "40px",
              boxSizing: "border-box",
            }}
          >
            <img
              src={item.img}
              alt={item.titulo}
              draggable={false}
              style={{
                width: "auto",
                height: "70vh",
                marginLeft: "200px",
                pointerEvents: "none",
                userSelect: "none",
                borderRadius: "20px",
              }}
            />
            <TextColumn>
              <Automec>{item.titulo}</Automec>

              <TextoAbaixo>
                {item.desc.map((bloco, i) => (
                  <p key={i}>
                    {bloco.title && <strong>{bloco.title}</strong>} {bloco.text}
                  </p>
                ))}
              </TextoAbaixo>
            </TextColumn>
          </Section>
        ))}
      </motion.div>
    </div>
  );
};

export default ProjetoMarketing;
